/**
 * Constants instead of typescript enums ---> smaller bundle size
 */
export const Vertical = 'vertical';
export const Horizontal = 'horizontal';
